import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import {
   GetAll,
   Delete
   } from "adminApi/ContactInformation/ContactInformation";
import DataTable from "Common/DataTable/DataTable";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/ContactInformationFields.json";
import { FilterStatus } from "utils/FilterStatus";

const ContactInformationTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const { tabledata } = fields;
  const sizeOptions = [10, 20, 50, 100];

  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Contact Information",
  });

  // Auto-generate display fields
  const displayFields = generateDisplayFields(tabledata);

  // Optional filter
  const filteredData = FilterStatus(data);

  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Contact Information",
      editUrl: "edit-contact-information",
      idKey: "id",
      deleteApi:Delete,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default ContactInformationTable;
